export default __webpack_public_path__ + "static/media/Faq.30eade34.svg";